import type {CreateUserPreference} from '../userPreferences/types';

export type ShortcutCommand =
  | 'globalLookup'
  | 'contextSearch'
  | 'showNew'
  | 'showPre'
  | 'showControl'
  | 'showChanged'
  | 'goToOverview'
  | 'undo'
  | 'save'
  | 'goToNext'
  | 'expandAllManifestations'
  | 'collapseAllManifestations'
  | 'expandAllChangeRequests'
  | 'collapseAllChangesRequests'
  | 'toggleWork'
  // Search (advanced)
  | 'focusColumnsFilter';

export type ShortcutCommandGroup =
  | 'global'
  | 'cataloguing'
  | 'overview'
  | 'search'
  | 'uncategorized';

export type ShortcutCommandMap = {
  [command in ShortcutCommand]?: string;
};

export type ShortcutGroupWithCommands = {
  group: ShortcutCommandGroup;
  commands: Array<ShortcutCommand>;
};

export const ActiveShortcutCommands: ShortcutCommand[] = [
  'globalLookup',
  'showNew',
  'showPre',
  'showControl',
  'showChanged',
  'goToOverview',
  'save',
  'undo',
  'goToNext',
  'contextSearch',
  'toggleWork',
  'expandAllManifestations',
  'collapseAllManifestations',
  'expandAllChangeRequests',
  'collapseAllChangesRequests',
  'focusColumnsFilter',
];

export const DefaultShortcuts: ShortcutCommandMap = {
  showNew: 'alt + 1',
  showPre: 'alt + 2',
  showControl: 'alt + 3',
  showChanged: 'alt + 4',

  goToOverview: 'alt + u',
  //globalLookup: 'alt + g',

  save: 'alt + d',
  undo: 'alt + z',
  goToNext: 'alt + v',
  contextSearch: 'alt + s',
  toggleWork: 'alt + h',

  expandAllManifestations: 'alt + x',
  collapseAllManifestations: 'alt + shift + x',
  expandAllChangeRequests: 'alt + c',
  collapseAllChangesRequests: 'alt + shift + c',

  focusColumnsFilter: 'alt + b',
};

export type ShortcutUserPreference = Omit<
  CreateUserPreference,
  'name' | 'category' | 'type'
> & {
  id?: string;
  name: ShortcutCommand;
  category: 'shortcut';
  type: 'USER_SPECIFIC';
};
